import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    data() {
        return {
            app: 'binance'
        };
    },
    props: {
        menuElError: {
            type: Boolean,
            required: true
        },
        menuLoaded: {
            type: Boolean,
            required: true
        },
        list: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { getHost() {
            return window.location.host;
        },
        getBybitLink() {
            return `https://${this.getHost}/bybit/`;
        },
        getMoexLink() {
            return 'https://moex.whitelist.capital/';
        }, exchanges() {
            const exchangesMap = {
                binance: {
                    name: 'Binance',
                    value: 'binance',
                    href: ''
                },
                bybit: {
                    name: 'Bybit',
                    value: 'bybit',
                    href: this.getBybitLink
                },
                okx: {
                    name: 'OKX',
                    value: 'okx',
                    href: '/binance/okx'
                },
                moex: {
                    name: 'MOEX',
                    value: 'moex',
                    href: this.getMoexLink
                }
            };
            // @ts-expect-error ///
            return this.menuElError || !this.menuLoaded ? [exchangesMap.binance] : this.list.map((exchange) => exchangesMap[exchange]);
        } })
});
